import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { useHttpContext } from '@/common/hooks/HttpContext';
import { toasts } from '@/common/toasts';
import { VisitReason } from '@/common/types';
import { OrganizationsTable } from '@/components/Organization/OrganizationsTable/OrganizationsTable';
import { LoadingSpinner } from '@/components/common/LoadingSpinner/LoadingSpinner';
import { Button } from '@/components/common/button/button';
import { resultIsError } from '@/services/HttpService';

export const AdminVisitReasonsContainer = () => {
    const { httpService } = useHttpContext();
    const { errorToast, successToast } = toasts;
    const [isLoading, setIsLoading] = useState(false);
    const [visitReasons, setVisitReasons] = useState<VisitReason[]>([]);
    const [newReason, setNewReason] = useState('');

    const getVisitReasons = async () => {
        setIsLoading(true);
        const res = await httpService.getAdminVisitReasons();
        if (resultIsError(res)) {
            errorToast('Unable to get visit reasons');
        } else {
            setVisitReasons(res);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        getVisitReasons();
    }, []);

    const handleCreate = async () => {
        if (!newReason.trim()) return;
        const res = await httpService.createVisitReason(newReason.trim());
        if (resultIsError(res)) {
            errorToast(res?.message || 'Could not create visit reason');
        } else {
            successToast('Created successfully.');
            setNewReason('');
            getVisitReasons();
        }
    };

    const columnStructure = [
        {
            Header: 'Reason',
            accessor: 'reason',
        },
    ];

    return (
        <div>
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <>
                    <OrganizationsTable columnStructure={columnStructure} data={visitReasons} />
                    <div
                        style={{
                            backgroundColor: 'white',
                            padding: '16px 24px 16px 40px',
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            alignItems: 'center',
                        }}
                    >
                        <TextField
                            size="small"
                            value={newReason}
                            onChange={(e) => setNewReason(e.target.value)}
                            placeholder="Enter reason"
                            onKeyDown={(e) => e.key === 'Enter' && handleCreate()}
                            variant="outlined"
                            inputProps={{ maxLength: 100 }}
                            sx={{ maxWidth: 300 }}
                        />
                        <div style={{ paddingLeft: '16px' }}>
                            <Button onClick={handleCreate} size="small" disabled={!newReason.trim()}>
                                Add
                            </Button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
